var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreGrayIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 16,
    viewBox: "0 0 4 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 8.83398C2.46007 8.83398 2.83317 8.46089 2.83317 8.00065C2.83317 7.54041 2.46007 7.16732 1.99984 7.16732C1.5396 7.16732 1.1665 7.54041 1.1665 8.00065C1.1665 8.46089 1.5396 8.83398 1.99984 8.83398Z",
    fill: "#667085"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 3.00065C2.46007 3.00065 2.83317 2.62755 2.83317 2.16732C2.83317 1.70708 2.46007 1.33398 1.99984 1.33398C1.5396 1.33398 1.1665 1.70708 1.1665 2.16732C1.1665 2.62755 1.5396 3.00065 1.99984 3.00065Z",
    fill: "#667085"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 14.6673C2.46007 14.6673 2.83317 14.2942 2.83317 13.834C2.83317 13.3737 2.46007 13.0007 1.99984 13.0007C1.5396 13.0007 1.1665 13.3737 1.1665 13.834C1.1665 14.2942 1.5396 14.6673 1.99984 14.6673Z",
    fill: "#667085"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 8.83398C2.46007 8.83398 2.83317 8.46089 2.83317 8.00065C2.83317 7.54041 2.46007 7.16732 1.99984 7.16732C1.5396 7.16732 1.1665 7.54041 1.1665 8.00065C1.1665 8.46089 1.5396 8.83398 1.99984 8.83398Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 3.00065C2.46007 3.00065 2.83317 2.62755 2.83317 2.16732C2.83317 1.70708 2.46007 1.33398 1.99984 1.33398C1.5396 1.33398 1.1665 1.70708 1.1665 2.16732C1.1665 2.62755 1.5396 3.00065 1.99984 3.00065Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.99984 14.6673C2.46007 14.6673 2.83317 14.2942 2.83317 13.834C2.83317 13.3737 2.46007 13.0007 1.99984 13.0007C1.5396 13.0007 1.1665 13.3737 1.1665 13.834C1.1665 14.2942 1.5396 14.6673 1.99984 14.6673Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreGrayIcon);
export default __webpack_public_path__ + "static/media/moreGrayIcon.e4fe030528a4fe55907db3b681458e2d.svg";
export { ForwardRef as ReactComponent };